import posthog from "posthog-js";

export function usePostHog() {
  // in Register and Login pages
  if (!window.EDRONE_CONTEXT) {
    posthog.init("phc_fAKclbfutuBrgK0Kj1LjGdxlyttmqpl4sbJauVYkFxq", {
      api_host: "https://eu.i.posthog.com",
      defaults: "2025-05-24",
      person_profiles: "identified_only",
      autocapture: false,
    });
    return { posthog };
  }

  // in Mission Control + other entries
  if (window.EDRONE_CONTEXT?.user?.isSupport === false) {
    posthog.init("phc_fAKclbfutuBrgK0Kj1LjGdxlyttmqpl4sbJauVYkFxq", {
      api_host: "https://eu.i.posthog.com",
      defaults: "2025-05-24",
      person_profiles: "identified_only",
      autocapture: false,
    });
    posthog.identify(window.EDRONE_CONTEXT.user.agentId.toString(), {
      email: window.EDRONE_CONTEXT.user.email,
      name: window.EDRONE_CONTEXT.user.firstName,
    });
    posthog.setPersonProperties({
      company_url: window.EDRONE_CONTEXT?.user.companyUrl || "",
      agent_email: window.EDRONE_CONTEXT?.user.email || "",
      agent_id: window.EDRONE_CONTEXT?.user?.agentId || "",
      creation_date: window.EDRONE_CONTEXT?.tracker.creationDate || "",
      tracker_id: window.EDRONE_CONTEXT?.trackerId || "",
      isDemo: window.EDRONE_CONTEXT?.isDemo || false,
      isPaying: window.EDRONE_CONTEXT?.tracker.isPaying || false,
      platform: window.EDRONE_CONTEXT?.tracker.platform || "",
      user_lang: window.EDRONE_CONTEXT?.user.lang || "",
      isPartner: window.EDRONE_CONTEXT?.user.isPartner,
    });
  }

  return { posthog };
}
